(function () {
  'use strict';
  var bar = document.querySelector('[data-ts-mobile-purchase]');
  var product = document.querySelector('pet-portrait-configurator');
  if (!bar || !product) return;
  var button = bar.querySelector('button');
  var price = bar.querySelector('[data-ts-mobile-price]');
  var compare = bar.querySelector('[data-ts-mobile-compare]');
  var media = window.matchMedia('(max-width: 749px)');
  var scheduled = false;
  function update() {
    scheduled = false;
    var submit = product.querySelector('[data-ppc-submit]');
    var currentPrice = product.querySelector('[data-ppc-price]');
    if (currentPrice) price.textContent = currentPrice.textContent;
    var currentCompare = product.querySelector('[data-ppc-compare]');
    if (compare) {
      compare.hidden = !currentCompare || currentCompare.hidden || !currentCompare.textContent.trim();
      compare.textContent = compare.hidden ? '' : currentCompare.textContent;
    }
    var keyboard = window.visualViewport && window.visualViewport.height < window.innerHeight * 0.8;
    var overlay = Array.from(document.querySelectorAll('dialog[open], [role="dialog"]')).some(function (element) {
      var rect = element.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0 && getComputedStyle(element).visibility !== 'hidden';
    });
    bar.hidden = !media.matches || !submit || submit.getBoundingClientRect().bottom >= 0 || overlay || keyboard;
  }
  function schedule() {
    if (!scheduled) { scheduled = true; window.requestAnimationFrame(update); }
  }
  button.addEventListener('click', function () {
    var groups = Array.from(product.querySelectorAll('[data-ppc-pet]:not([hidden])'));
    var missing = groups.find(function (group) {
      var file = group.querySelector('input[type="file"]');
      var name = group.querySelector('[data-ppc-name]');
      return (file && !file.disabled && !file.files.length) || (name && name.required && !name.value.trim());
    });
    var target = missing || product.querySelector('.ppc-form') || product;
    var top = window.scrollY + target.getBoundingClientRect().top - 90;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: Math.max(0, top), behavior: reduced ? 'auto' : 'smooth' });
  });
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('pageshow', schedule);
  document.addEventListener('click', schedule);
  document.addEventListener('toggle', schedule, true);
  new MutationObserver(schedule).observe(product, { childList: true, characterData: true, subtree: true });
  var drawer = document.querySelector('#ts-drawer');
  if (drawer) new MutationObserver(schedule).observe(drawer, { attributes: true, attributeFilter: ['class', 'hidden', 'aria-hidden', 'open'] });
  if (window.visualViewport) window.visualViewport.addEventListener('resize', schedule);
  update();
})();
